import cn from "classnames";

import { CompareTableIcon } from "@/components/compareTableSection/compareTableIcon.component";
import { Text } from "@/components/text/text.component";

import type { CompareCompetitorTableAppearance } from "@/sanity/defaults/compareCompetitorTable.defaults";

import {
  competitorCellTextVariant,
  dataColumnTextClass,
} from "./compareCompetitorTable.tableUtils";
import type { SanityCompetitorCompareCell } from "./compareCompetitorTable.type";
import { competitorCellToIconValue } from "./compareCompetitorTableCell";

export const CompareCompetitorTableValue = ({
  cell,
  columnIndex,
  highlightIndex,
  appearance,
}: CompareCompetitorTableValueProps) => {
  const caption = cell?.caption?.trim();
  const cellTextVariant = competitorCellTextVariant(
    appearance,
    columnIndex,
    highlightIndex,
  );
  const textClassName = dataColumnTextClass(
    columnIndex,
    highlightIndex,
    appearance,
  );

  return (
    <div className="flex flex-col items-center justify-center gap-1">
      <CompareTableIcon
        value={competitorCellToIconValue(cell)}
        textClassName={textClassName}
        textVariant={cellTextVariant}
      />
      {caption ? (
        <Text
          variant={cellTextVariant}
          component="p"
          className={cn("text-center", textClassName)}>
          {caption}
        </Text>
      ) : null}
    </div>
  );
};

type CompareCompetitorTableValueProps = {
  cell: SanityCompetitorCompareCell | undefined;
  columnIndex: number;
  highlightIndex: number;
  appearance: CompareCompetitorTableAppearance;
};
